import { baseService } from '@services/base.service';
import { MajorListSort, MajorsResult } from '@common-types';
import { GetMajorsParams, FormattedParams } from '@api/types';
import { DESKTOP_PER_PAGE_OPTIONS } from '@constants';
import { getStateSpotlightLocationParams } from '@constants/stateSpotlight';

export const getMajors = async ({
  filters,
  sortByValues,
  isSortSelected = false,
  useStateSorts = false,
}: GetMajorsParams): Promise<MajorsResult> => {
  const { skip, limit } = filters;
  const params: FormattedParams = {
    limit: limit || DESKTOP_PER_PAGE_OPTIONS[0],
  };

  if (skip) {
    params.skip = skip;
  }

  const arrayFields = ['cipCodes', 'awardLevels'] as const;
  arrayFields.forEach((field) => {
    const value = filters[field];
    if (value?.length) {
      params[field] = value.join(',');
    }
  });

  const booleanFields = ['careerFit', 'careerFavorite', 'certificationsEarned'] as const;
  booleanFields.forEach((field) => {
    if (filters[field]) {
      params[field] = Array.isArray(filters[field]) ? filters[field].join(',') : filters[field];
    }
  });

  Object.assign(params, getStateSpotlightLocationParams(filters));

  const toBackendSort = (sort: MajorListSort) => {
    if (!useStateSorts) return sort;
    if (sort === MajorListSort.BEST_FIT) return MajorListSort.BEST_FIT_UTAH;
    if (sort === MajorListSort.CIP_TITLE) return MajorListSort.CIP_TITLE_UTAH;

    return sort;
  };

  const hasCareerFilter = !!(params.careerFit || params.careerFavorite || params.certificationsEarned);

  if (hasCareerFilter && !isSortSelected) {
    params.sort = toBackendSort(MajorListSort.BEST_FIT);
  } else if (sortByValues?.sort === MajorListSort.BEST_FIT) {
    params.sort = toBackendSort(MajorListSort.BEST_FIT);
  } else if (sortByValues) {
    params.sort = toBackendSort(sortByValues.sort);
    params.sortDirection = sortByValues.sortDirection;
  }

  return baseService.getAsync<MajorsResult>('/majors', { params });
};

export const getMajorsByCipCodes = async (cipCodes: string[]): Promise<MajorsResult> =>
  baseService.getAsync<MajorsResult>('/majors', {
    params: { exactCipCodes: cipCodes.join(','), limit: cipCodes.length },
  });
